/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 10:16:42
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title9 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormTable from './FormTable';
class P9 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumns: [],
      tableList: [],
      tableColorList: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  fillColor = () => {
    const { tableColorList, tableColumns } = this.state;
    return tableColumns.map(item => ({
      ...item,
      style: {
        ...item.style,
        background: tableColorList[0],
        color: tableColorList[1],
        borderTop: `2px solid ${tableColorList[2]}`,
        borderRight: `2px solid ${tableColorList[2]}`,
        borderBottom: `2px solid ${tableColorList[2]}`,
      },
      colStyle: {
        ...item.colStyle,
        borderRight: `2px solid ${tableColorList[2]}`,
        borderBottom: `2px solid ${tableColorList[2]}`,
      }
    }))
  }

  render() {
    const { chartTitle, chartList, tableList, tableColorList, chartColorList } = this.state;
    const column = this.fillColor();

    return (
      <Stage>
        <Title9 pageNumber="7">公众认知匹配度分析</Title9>

        <div className={s.content}>
          <div style={{ paddingBottom: 10 }}>
            <div contentEditable className={s.subTitle}>公众认知存在偏差，控股的品牌理念传递不足</div>
            <div contentEditable className={s.des}>
            传播关键词“投资”“科技”“创新”获得用户核心认知，传播效果较好，有效触达用户心智。“医疗”板块强势，“回报”也成为联想控股一大亮点。但“实业”“专精特新”“制造卓越企业”等关键词暂未形成品牌印象。
            </div>
            <div contentEditable className={s.des}>
            用户认知中以正面印象为主，“投资”“科技”的负面词频占比稍高，主要与投资项目势力以及被指责“技术空心化”有关。值得注意的是，由于创始人的个人话题性太强，一定程度上影响了控股的品牌理念传播。反映在“公司品牌”方向上的制造卓越企业、产业报国、产业运营、社会责任等关键词较少被公众谈论。
            </div>
          </div>
          <div className={s.uiWrapper}>
            <div className={s.tableWrapper}>
              <div className={s.tableTitle} contentEditable>品牌主要传播关键词词频</div>
              <TooltipDrawer formContent={<FormTable onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={column} data={tableList} style={{ borderLeft: `2px solid ${tableColorList[2]}`}} />
              </TooltipDrawer>
            </div>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({ label: chartTitle, list: chartList, color: chartColorList })} />
              </TooltipDrawer>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P9);



// WEBPACK FOOTER //
// src/routes/visualChart/P9/index.js